module.exports = __webpack_public_path__ + "img/fail.e15ed047.png";